import { Line } from 'react-chartjs-2'
import React, { useCallback } from 'react'
import { colors } from 'variables/charts.js'

import { useState, useEffect } from 'react'

import { Card, CardHeader, CardBody } from 'reactstrap'
import { useDashboardContext } from '../../contexts/DashboardContext'

function TerminationHistoryLineChart({
  startDate,
  endDate,
  timePeriod,
  costCtrId
}) {
  const [terminationHistoryList, setTerminationHistoryList] = useState([])
  const { getTerminationHistory } = useDashboardContext()

  const loadTerminationHistory = useCallback(async () => {
    if (startDate === null || endDate === null) {
      return
    }
    console.log('load termination history')
    await getTerminationHistory({
      startDate,
      endDate,
      timePeriod,
      costCtrId
    })
      .then((response) => {
        setTerminationHistoryList(response)
        //console.log('set termination history: ', response)
      })
      .catch((err) => {
        console.log('error at dashboard')
      })
  }, [getTerminationHistory, startDate, endDate, timePeriod, costCtrId])

  const getTerminationLable = () => {
    if (timePeriod === 'Day' || timePeriod === 'Week') {
      const list = terminationHistoryList.map((data) =>
        new Date(data.Date).toLocaleDateString('es-AU', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      )
      return list
    }
    if (timePeriod === 'Month') {
      const list = terminationHistoryList.map((data) =>
        new Date(data.Date).toLocaleDateString('en-AU', {
          year: '2-digit',
          month: 'short'
        })
      )
      return list
    }
    if (timePeriod === 'Year') {
      const list = terminationHistoryList.map((data) =>
        new Date(data.Date).toLocaleDateString('en-AU', {
          year: 'numeric'
        })
      )
      return list
    }
  }

  const getTerminationData = () => {
    const list = terminationHistoryList.map((data) => data.Count)

    return list
  }

  useEffect(() => {
    loadTerminationHistory()
  }, [loadTerminationHistory])

  return (
    <>
      <Card>
        <CardHeader>
          <h5 className="text-uppercase text-muted mb-0">Termination History</h5>
        </CardHeader>
        <CardBody>
          <div className="chart">
            <Line
              data={{
                labels: getTerminationLable(),
                datasets: [
                  {
                    label: 'number of termination',
                    data: getTerminationData(terminationHistoryList)
                  }
                ]
              }}
              options={{
                legend: {
                  display: false
                },
                scales: {
                  yAxes: [
                    {
                      gridLines: {
                        color: colors.gray[200],
                        zeroLineColor: colors.gray[200]
                      },
                      ticks: {}
                    }
                  ]
                },
                onClick: (e, element) => {
                  console.log('getevent', e)
                  console.log(
                    'getelement',
                    element,
                    terminationHistoryList[element[0]._index].Count
                  )
                }
              }}
              className="chart-canvas"
              id="chart-bars"
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default TerminationHistoryLineChart